import { makeApi } from "@zodios/core";
import { z } from "zod";

const permissionsSchema = z.object({
  saveTemplates: z.boolean(),
});

export type Permissions = z.infer<typeof permissionsSchema>;

export const permissionsApi = makeApi([
  {
    method: "get",
    path: "/permissions",
    parameters: [],
    alias: "getPermissions",
    response: permissionsSchema,
  },
]);
